import { ScanSearch, Sparkles, CheckCircle2, Zap, ArrowRight } from "lucide-react";

const features = [
  "Skor SEO 0-100",
  "3 fitur konversi hilang",
  "Speed test di HP",
  "Rekomendasi upgrade",
];

function openModal() {
  window.dispatchEvent(new CustomEvent("open-audit-modal"));
}

export default function AuditBanner() {
  return (
    <section
      id="audit"
      data-testid="audit-banner-section"
      className="py-20 lg:py-24 bg-[var(--brand-cream)]"
    >
      <div className="mx-auto max-w-7xl px-5">
        <div className="relative overflow-hidden rounded-3xl bg-[var(--brand-ink)] p-8 lg:p-14 text-white">
          <div className="absolute inset-0 dotted-grid opacity-10 pointer-events-none" />
          <div className="pointer-events-none absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[var(--brand-azure)] blur-3xl opacity-30" />
          <div className="pointer-events-none absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-[var(--brand-gold)] blur-3xl opacity-20" />

          <div className="relative grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 rounded-full bg-[var(--brand-gold)] text-[var(--brand-ink)] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em]">
                <Sparkles className="w-3 h-3" /> 100% Gratis · Tanpa Ikatan
              </div>
              <h2 className="mt-4 font-display text-3xl md:text-5xl font-semibold leading-[1.05]">
                Audit Website UMKM Anda —<br />
                <em className="not-italic text-[var(--brand-gold)]">Gratis dari Saya.</em>
              </h2>
              <p className="mt-5 text-white/80 max-w-xl leading-relaxed">
                Isi form 30 detik, saya kirim review lengkap ke WhatsApp Anda dalam
                <strong className="text-white"> 24 jam</strong>. Cocok untuk pemilik UMKM
                yang website-nya sepi orderan atau mau bikin website baru tapi bingung
                mulai dari mana.
              </p>

              <ul className="mt-6 grid grid-cols-2 gap-3 max-w-md">
                {features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-sm text-white/85">
                    <CheckCircle2 className="w-4 h-4 text-[var(--brand-gold)] shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>

              <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <button
                  onClick={openModal}
                  data-testid="audit-banner-cta"
                  className="cta-shine inline-flex items-center gap-2 rounded-full bg-[var(--brand-gold)] text-[var(--brand-ink)] px-6 py-3.5 text-sm font-bold hover:bg-[#ffcc3b] transition"
                >
                  <ScanSearch className="w-4 h-4" />
                  Minta Audit Gratis Sekarang
                  <ArrowRight className="w-4 h-4" />
                </button>
                <span className="text-xs text-white/60">
                  ⏱️ Response &lt; 2 jam di hari kerja
                </span>
              </div>
            </div>

            {/* Visual side */}
            <div className="lg:col-span-5">
              <div className="relative aspect-[4/3] rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6 overflow-hidden">
                <div className="text-[10px] uppercase tracking-[0.25em] text-[var(--brand-gold)] font-bold">
                  Contoh Hasil Audit
                </div>
                <div className="mt-4 space-y-3">
                  <div className="flex items-center justify-between p-3 rounded-xl bg-white/5 border border-white/10">
                    <span className="text-xs text-white/70">Skor SEO</span>
                    <span className="text-lg font-bold text-[var(--brand-gold)]">42/100</span>
                  </div>
                  <div className="flex items-center justify-between p-3 rounded-xl bg-white/5 border border-white/10">
                    <span className="text-xs text-white/70">Speed Mobile</span>
                    <span className="text-lg font-bold text-red-400">2.8s ⚠️</span>
                  </div>
                  <div className="flex items-center justify-between p-3 rounded-xl bg-white/5 border border-white/10">
                    <span className="text-xs text-white/70">Konversi Missing</span>
                    <span className="text-lg font-bold text-white">3 fitur</span>
                  </div>
                  <div className="p-3 rounded-xl bg-[var(--brand-gold)]/10 border border-[var(--brand-gold)]/30">
                    <div className="text-[10px] uppercase tracking-wide text-[var(--brand-gold)] font-bold">
                      Rekomendasi Utama
                    </div>
                    <div className="mt-1 text-xs text-white/85 leading-relaxed">
                      Tambah tombol WA di setiap produk, kompres foto ke WebP, dan
                      buat halaman produk SEO-friendly.
                    </div>
                  </div>
                </div>
                <div className="absolute -top-6 -right-6 h-16 w-16 rounded-2xl bg-[var(--brand-gold)] text-[var(--brand-ink)] flex items-center justify-center rotate-12 shadow-xl">
                  <Zap className="w-8 h-8" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
